import { apiOssProxyInternal } from "./api";

export type FeatureFlag = {
  enabled: boolean;
  values?: string[];
};

export type FeatureFlagsResponse = {
  featureFlags: Record<string, FeatureFlag>;
  updatedBy: string;
  id: string;
  updatedAt: string;
  version: number;
};

export type FeatureFlagsUpdateRequest = {
  featureFlags: Record<string, FeatureFlag>;
  updatedBy: string;
  existingVersion: number;
};

export async function getFeatureFlags(): Promise<FeatureFlagsResponse> {
  const resp = await apiOssProxyInternal.get("/feature-flags");
  if (!resp.data) throw new Error("Feature flags not returned");
  return resp.data;
}

export async function updateFeatureFlags(
  update: FeatureFlagsUpdateRequest
): Promise<FeatureFlagsResponse> {
  const resp = await apiOssProxyInternal.post("/feature-flags", update);
  if (!resp.data) throw new Error("Feature flags update failed");
  return resp.data;
}
